import Dexie from "dexie";
import type { SchemaNames } from "instantdb/types";

export type ResourceOrderEntry = {
  key: SchemaNames;
  value: string;
};

export type PreferenceEntry = {
  key: string;
  value: unknown;
};

class ProgressMadeDB extends Dexie {
  resourceOrdering!: Dexie.Table<ResourceOrderEntry>;
  preferences!: Dexie.Table<PreferenceEntry>;

  constructor() {
    super("progressmade-db");
    this.version(5).stores({
      resourceOrdering: "key",
      preferences: "key",
    });
  }
}

export const db = new ProgressMadeDB();
